// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jU-z","hovered":"kU-z","hoverImage":"lU-z","mainImage":"mU-z","imageNoBackground":"nU-z","fullSizeImage":"oU-z"};